import script from "./ChangePasswordFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordFrame.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePasswordFrame.vue?vue&type=style&index=0&id=c2bd17e6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2bd17e6"]])

export default __exports__